
  import { Component, Vue ,Prop ,Watch} from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import Dialog from '@/components/dialog.vue';
  import {
    productproductClassSave
  } from "@/api/order"
  @Component({  
    name: '',
    components: {
      PageFooter,
      'slz-dialog': Dialog,
    }
  })

  export default class ProductList extends Vue {
    @Prop({default:false,}) show:boolean
    @Prop({default:()=>{
      return {}
    }}) row:any
    @Prop({default:'400px',}) width:boolean
    private diaShow = false

    @Watch('show')
    private watchShow(val){
      this.diaShow = val
    }



    private async confirm(){
      if(!this.row.ClassName){
        this.$message.error('请输入类目名称')
        return 
      }
      try{
        let res = await productproductClassSave(this.row)
        if(res.IsSuccess){
          this.$message.success('已创建')
          this.$emit('confirm')
        }
      }finally{
        this.close()
      }
    }
    private close(){
      this.diaShow = false
      this.$emit('close',false)
    }
  }
